import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as services from "../services/services";
import toast from "react-hot-toast";

export const useInventoryMutations = (activeTab) => {
  const queryClient = useQueryClient();

  const createMutation = useMutation({
    mutationFn: (data) => services.createInventorySetting({ ...data, settingType: activeTab }),
    onSuccess: () => {
      queryClient.invalidateQueries(["inventory-settings", activeTab]);
      toast.success("Added successfully");
    },
    onError: (err) => {
      toast.error(err.response?.data?.message || "Failed to add");
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, data }) => services.updateInventorySetting(id, { ...data, settingType: activeTab }),
    onSuccess: () => {
      queryClient.invalidateQueries(["inventory-settings", activeTab]);
      toast.success("Updated successfully");
    },
    onError: (err) => {
      toast.error(err.response?.data?.message || "Failed to update");
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (id) => services.deleteInventorySetting(id, { settingType: activeTab }),
    onSuccess: () => {
      queryClient.invalidateQueries(["inventory-settings", activeTab]);
      toast.success("Deleted successfully");
    },
    onError: () => {
      toast.error("Failed to delete");
    },
  });

  return {
    createItem: createMutation.mutateAsync,
    updateItem: updateMutation.mutateAsync,
    deleteItem: deleteMutation.mutateAsync,
    isProcessing: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending,
  };
};
